import React, { useRef, useState, useEffect } from "react";
import ReactDOM from 'react-dom';

import videojs from 'video.js'
import 'video.js/dist/video-js.css';
import Transcript from './transcript/videojs-transcript'
import { HighlightHTML } from "@learningblocks/storybook-components";

import parse from 'html-react-parser';

import "./index.scss";

export function Video(props) {

  const videoNode = useRef(null);
  const transcriptArea = useRef(null);

  const [player, setPlayer] = useState(null);
  const [viewTranscript, setViewTranscript] = useState(false);

  useEffect(()=>{

    setPlayer(
      videojs(videoNode.current, {
        sources: [
          {
            src: props.video,
            type: 'application/x-mpegURL'
          }
        ],
        controlBar: {
          playToggle: true,
          captionsButton: props.captions ? true : false,
          chaptersButton: false,
          subtitlesButton: false,
          remainingTimeDisplay: true,
          progressControl: {
            seekBar: true
          },
          fullscreenToggle: true,
          volumePanel: {inline: true},
          playbackRateMenuButton: true,
          pictureInPictureToggle: false
        },
        playbackRates: [0.5,0.75,1,1.25,1.5,1.75,2],
        castButton: false,
        textTrackSettings: true
      }, function onPlayerReady() {
        if(player !== null){
          getTranscript(props.srt)
        }
      })
    )

    Transcript(window, videojs)

  }, []);

  useEffect(()=>{
    if(player !== null){

      getTranscript(props.srt);

      //window.addEventListener('resize', setTranscriptBtns());

    }
  },[player]);

  const setTranscriptBtns = () => {
    let myButton = player.controlBar.addChild("button");
    myButton.addClass('transcript-btn')
    let myButtonDom = myButton.el();
    myButtonDom.innerHTML = `<span style="cursor: pointer; font-size: 14px">Transcript</span>`;
    myButtonDom.style.display = (window.innerWidth <= 720 ? "none" : "block");
    let myButton2 = player.controlBar.addChild("button");
    myButton2.addClass('transcript-btn')
    let myButtonDom2 = myButton2.el();
    myButtonDom2.innerHTML = `<span style="cursor: pointer; font-size: 14px; border-bottom: 1px solid white;">Transcript</span>`;
    myButtonDom2.style.display = (window.innerWidth <= 720 ? "none" : "none");

    myButtonDom.onclick = () => {
      setViewTranscript(true);
      myButtonDom.style.display = "none";
      myButtonDom2.style.display = "block";
    }
    myButtonDom2.onclick = () => {
      setViewTranscript(false);
      myButtonDom2.style.display = "none";
      myButtonDom.style.display = "block";
    }
  };

  const getTranscript = (url) => fetch(url)
    .then(function (response) {

      // console.log("transcript", response)
      return response.text();
    }).then(function (data) {

      let trackBlob = new Blob([srt2webvtt(data)], {
        type: "text/plain;charset=utf-8"
      })

      let captionOption = {
        kind: 'captions',
        srclang: 'en',
        label: 'English',
        src: URL.createObjectURL(trackBlob)
      };

      player.addRemoteTextTrack(captionOption);


      let transcript = player.transcript({
        showTitle: false,
        showTrackSelector: false
      })

      let node = ReactDOM.findDOMNode(transcriptArea.current);
      node.appendChild(transcript.el());

  }.bind(player));


  const srt2webvtt = (data) => {
    // remove dos newlines
    let srt = data.replace(/\r+/g, '');
    // trim white space start and end
    srt = srt.replace(/^\s+|\s+$/g, '');
    // get cues
    let cuelist = srt.split('\n\n');
    let result = "";
    if (cuelist.length > 0) {
      result += "WEBVTT\n\n";
      for (let i = 0; i < cuelist.length; i = i + 1) {
        result += convertSrtCue(cuelist[i]);
      }
    }
    return result;
  }

  const convertSrtCue = (caption) => {
    // remove all html tags for security reasons
    //srt = srt.replace(/<[a-zA-Z\/][^>]*>/g, '');
    let cue = "";
    let s = caption.split(/\n/);
    // concatenate muilt-line string separated in array into one
    while (s.length > 3) {
      for (let i = 3; i < s.length; i++) {
        s[2] += "\n" + s[i]
      }
      s.splice(3, s.length - 3);
    }
    let line = 0;
    // detect identifier
    if (!s[0].match(/\d+:\d+:\d+/) && s[1].match(/\d+:\d+:\d+/)) {
      cue += s[0].match(/\w+/) + "\n";
      line += 1;
    }
    // get time strings
    if (s[line].match(/\d+:\d+:\d+/)) {
      // convert time string
      let m = s[1].match(/(\d+):(\d+):(\d+)(?:,(\d+))?\s*--?>\s*(\d+):(\d+):(\d+)(?:,(\d+))?/);
      if (m) {
        cue += m[1] + ":" + m[2] + ":" + m[3] + "." + m[4] + " --> "
          + m[5] + ":" + m[6] + ":" + m[7] + "." + m[8] + "\n";
        line += 1;
      } else {
        // Unrecognized timestring
        return "";
      }
    } else {
      // file format error or comment lines
      return "";
    }
    // get cue text
    if (s[line]) {
      cue += s[line] + "\n\n";
    }
    return cue;
  }

  const video = (
    <div className="basicVideo" id="basicVideo">
      <div className="video-container">
        <video
          ref={videoNode}
          className={`video-js custom-videojs-components vjs-big-play-centered vjs-fluid`}
          id="my-player"
          controls
          preload="true"
        >
          <p className="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a
            web browser that
            <a href="https://videojs.com/html5-video-support/" target="_blank">
              supports HTML5 video
            </a>
          </p>
        </video>
        <div className="custom-video-js-transcript" ref={transcriptArea}
          style={{display: !viewTranscript ? "none" : null}}
        ></div>
      </div>
    </div>
  )

  if (props.caption) {
    return (
      <figure className="fullWidthVideo">
        {video}
        <figcaption>
          <HighlightHTML
            key={props.id}
            content={props.caption}
            getContentData={props.getGlossaryItem}
            openGlossary={props.onOpenGlossary}
          />
        </figcaption>
      </figure>
    );
  } else {
    return video;
  }
}
